var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotePen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7312 2.76884C20.706 1.74372 19.044 1.74372 18.0188 2.76884L16.8617 3.92599L20.574 7.6383L21.7312 6.48116C22.7563 5.45603 22.7563 3.79397 21.7312 2.76884Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5133 8.69896L15.801 4.98665L7.40019 13.3875C6.78341 14.0043 6.33002 14.765 6.081 15.601L5.28122 18.2859C5.2026 18.5498 5.27494 18.8356 5.46967 19.0303C5.6644 19.225 5.95019 19.2974 6.21412 19.2188L8.89901 18.419C9.73498 18.17 10.4957 17.7166 11.1125 17.0998L19.5133 8.69896Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.74999C3.59315 5.74999 2.25 7.09314 2.25 8.74999V19.25C2.25 20.9068 3.59315 22.25 5.25 22.25H15.75C17.4069 22.25 18.75 20.9068 18.75 19.25V14C18.75 13.5858 18.4142 13.25 18 13.25C17.5858 13.25 17.25 13.5858 17.25 14V19.25C17.25 20.0784 16.5784 20.75 15.75 20.75H5.25C4.42157 20.75 3.75 20.0784 3.75 19.25V8.74999C3.75 7.92156 4.42157 7.24999 5.25 7.24999H10.5C10.9142 7.24999 11.25 6.91421 11.25 6.49999C11.25 6.08578 10.9142 5.74999 10.5 5.74999H5.25Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotePen);
export default __webpack_public_path__ + "static/media/Icon_NotePen.0d88fda06383f20bc9ebfa36976bd067.svg";
export { ForwardRef as ReactComponent };